export default "__VITE_ASSET__DRNPM0HQ__"